export const DateFormats = {
  Default: 'DD/MM/YYYY',
  MonthNameFirst: 'll',
  TwoDigitYear: 'DD/MM/YY',
  WithoutYear: 'DD/MM',
  Full: 'DD/MMM/YYYY',
  MonthOnly: 'MMM',
  ShortYear: 'YY',
  LongMonth: 'MMMM',
  LongMonthAndYear: 'MMMM YYYY',
};

export const DateTimeFormats = {
  Default: 'DD/MM/YYYY hh:mm A',
  MessageDateTime: 'ddd h:mm A',
  FullDateTime: 'dddd, MMMM Do YYYY, h:mm A'
};

export const NumberFormats = {
  Default: 'default',
  Percentage: 'percentage',
  ShortPercentage: 'percentage_short',
  Currency: 'currency',
  ShortCurrency: 'currency_short',
  SignedInteger: 'signed_integer',
};
